
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intake",
      function () {
        return require("private-next-pages/intake/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intake"])
      });
    }
  